/* esm.sh - @internetarchive/reviews@1.1.0 */
import{__decorate as d}from"/tslib?target=es2022";import{html as p,css as te,LitElement as ie,nothing as S}from"/lit@^2.8.0?target=es2022";import{property as w,customElement as re,state as E,query as oe}from"/lit@^2.8.0/decorators?target=es2022";import{msg as m}from"/@lit/localize@^0.12.2?target=es2022";import{unsafeHTML as se}from"/lit@^2.8.0/directives/unsafe-html?target=es2022";import ne from"/dompurify@^3.2.5?target=es2022";import{iaButtonStyles as ae}from"/@internetarchive/ia-styles@^1.0.0?target=es2022";import"/@internetarchive/ia-activity-indicator@^0.0.6?target=es2022";import{Review as le}from"/@internetarchive/metadata-service@^1.0.4?target=es2022";import{svg as z}from"/lit@^2.8.0?target=es2022";var I=z`
  <svg class="star-selected" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path
    d="m81.0388846 100-30.9636029-22.5595033-30.7410319 22.5595033 10.6670595-37.3922042-30.0013093-25.2155916h37.5556428l12.5196389-37.3922042 12.3690754 37.3922042h37.5556429l-29.7034563 25.2155916z"
    fill="#c2820a"
    stroke="#c2820a"
    stroke-width="3px"
  />
</svg>`;import{svg as G}from"/lit@^2.8.0?target=es2022";var D=G`
  <svg class="star-unselected" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path
    d="m81.0388846 100-30.9636029-22.5595033-30.7410319 22.5595033 10.6670595-37.3922042-30.0013093-25.2155916h37.5556428l12.5196389-37.3922042 12.3690754 37.3922042h37.5556429l-29.7034563 25.2155916z"
    fill="#ffffff"
    stroke="#c2820a"
    stroke-width="3px"
  />
</svg>`;import{__decorate as u}from"/tslib?target=es2022";import{html as b,css as J,LitElement as K,nothing as x}from"/lit@^2.8.0?target=es2022";import{property as R,customElement as Q,query as O,state as N}from"/lit@^2.8.0/decorators?target=es2022";import{msg as y}from"/@lit/localize@^0.12.2?target=es2022";import{ifDefined as Y}from"/lit@^2.8.0/directives/if-defined?target=es2022";import{unsafeHTML as ee}from"/lit@^2.8.0/directives/unsafe-html?target=es2022";import{svg as U}from"/lit@^2.8.0?target=es2022";var H=U`
  <svg class="star-basic" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path
    d="m81.0388846 100-30.9636029-22.5595033-30.7410319 22.5595033 10.6670595-37.3922042-30.0013093-25.2155916h37.5556428l12.5196389-37.3922042 12.3690754 37.3922042h37.5556429l-29.7034563 25.2155916z"
    fill="2C2C2C"
  />
</svg>`;import{html as W}from"/lit@^2.8.0?target=es2022";function C(n=""){if(n.length<=40)return n;let t=n.substring(0,40)+"...";return W`<span title="${n}">${t}</span>`}import P from"/dompurify@^3.2.5?target=es2022";var q=["a"];function B(n){return P.addHook("afterSanitizeAttributes",e=>{e.nodeName.toLowerCase()==="a"&&(e.setAttribute("rel","ugc nofollow"),e.setAttribute("target","_blank"))}),P.sanitize(n,{ALLOWED_TAGS:q})}function A(n,e=100,t=!0){if(n.length<e)return n;let i=e;if(t){let r=n.indexOf(" ",e),o=r-e<=20;if(o&&r===n.length-1)return n;r!==-1&&o&&(i=r)}return V(n,i,e)}function V(n,e,t){let i=n.slice(0,e),r=i.match(/<a/gi);if(r){let o=i.match(/<\/a/gi);if(!o||o.length<r.length){let c=n.indexOf("</a>",e),f=c-t<=20;if(f&&n.length===c+4)return n;if(c!==-1&&f)i=n.slice(0,c+4);else{let k=i.lastIndexOf("<a");i=n.slice(0,k)}}}return i.concat("...")}var X=/(http(s)?)?(:\/\/)?([a-zA-Z][-a-z0-9]*(\.[-a-z0-9]+)+(\/[^\s\?#<]*)*(\?[^\s#]*)?(#[^\s]*)?)/;function j(n){return n.replace(/href="([^"]+)"/,(i,r)=>`href="${r.replace(".","__DOT__")}"`).replace(X,i=>i=`<a href="${i.match(/^(https|http)/)?i:"https://"+i}" rel="ugc nofollow" target="_blank">${i}</a>`).replace("__DOT__",".")}function M(n){return n.trim().replace(/[ |\t]+/g," ").replace(/[\n|\r\n]+/g,"<br />").replace(/(<br[^>]*>(<\/br>)?)+/g,"<br />")}import{svg as Z}from"/lit@^2.8.0?target=es2022";var F=Z`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="delete-icon">
    <rect width="24" height="24" fill="white"/>
    <path d="M5 7.5H19L18 21H6L5 7.5Z" stroke="#000000" stroke-linejoin="round"/>
    <path d="M15.5 9.5L15 19" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 9.5V19" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.5 9.5L9 19" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16 5H19C20.1046 5 21 5.89543 21 7V7.5H3V7C3 5.89543 3.89543 5 5 5H8M16 5L15 3H9L8 5M16 5H8" stroke="#000000" stroke-linejoin="round"/>
  </svg>
`;var v=class extends K{constructor(){super(...arguments),this.maxSubjectLength=100,this.maxBodyLength=150,this.baseHost="https://archive.org",this.csrfToken="",this.canDelete=!1,this.bypassTruncation=!1,this.showTruncatedContent=!1,this.deleteMsg=""}render(){return this.review?b`
          <article
            class="review"
            id=${this.generateDomId()}
            tabindex=${Y(this.hasReviewerLink?void 0:"-1")}
          >
            ${this.canDelete?b`
                  <button
                    class="delete-btn"
                    title="Delete this review"
                    @click=${this.deleteReview}
                  >
                    ${F}
                  </button>
                `:x}
            <div class="top-line">
              <b>${y("Reviewer:")}</b> ${this.reviewerTemplate} -
              ${this.starsTemplate}${this.createDateTemplate}
            </div>
            <div class="subject">
              <b>${y("Subject: ")}</b>${this.subjectTemplate}
            </div>
            <div class="body">
              ${this.deleteMsg?b`<i>${y(this.deleteMsg)}</i>`:this.bodyTemplate}
            </div>
            ${this.truncationButtonsTemplate}
          </article>
        `:b`
          <div class="error">
            ${y("This review cannot be displayed at this time.")}
          </div>
        `}focus(e){var t,i;(i=(t=this.reviewerLink)!==null&&t!==void 0?t:this.reviewArticle)===null||i===void 0||i.focus(e)}get hasReviewerLink(){var e;return!!(!((e=this.review)===null||e===void 0)&&e.reviewer_itemname)}get subjectTemplate(){var e;let t=(e=this.review)===null||e===void 0?void 0:e.reviewtitle;return this.truncateContent(t??"",this.maxSubjectLength)}get bodyTemplate(){var e;let t=(e=this.review)===null||e===void 0?void 0:e.reviewbody;if(!t)return x;let i=B(t),r=this.truncateContent(i,this.maxBodyLength);return b`${ee(this.prepReview(r))}`}get truncationButtonsTemplate(){var e,t,i,r,o,c;return this.bypassTruncation?x:((i=(t=(e=this.review)===null||e===void 0?void 0:e.reviewtitle)===null||t===void 0?void 0:t.length)!==null&&i!==void 0?i:0)<=this.maxSubjectLength&&((c=(o=(r=this.review)===null||r===void 0?void 0:r.reviewbody)===null||o===void 0?void 0:o.length)!==null&&c!==void 0?c:0)<=this.maxBodyLength?x:this.showTruncatedContent?this.lessButtonTemplate:this.moreButtonTemplate}get moreButtonTemplate(){return b`
      <button
        class="simple-link more-btn"
        @click=${()=>this.showTruncatedContent=!0}
      >
        ${y("More...")}
      </button>
    `}get lessButtonTemplate(){return b`<button
      class="simple-link less-btn"
      @click=${()=>this.showTruncatedContent=!1}
    >
      ${y("...Less")}
    </button>`}get reviewerTemplate(){return this.review?this.hasReviewerLink?b`
            <a
              href="${this.baseHost}/details/${this.review.reviewer_itemname}"
              class="reviewer-link simple-link"
              data-event-click-tracking="ItemReviews|ReviewerLink"
            >
              ${C(this.review.reviewer)}
            </a>
          `:b`${C(this.review.reviewer)}`:x}get starsTemplate(){return!this.review||!this.review.stars?x:b`
      <div
        class="review-stars"
        title="${y(`${this.review.stars} out of 5 stars`)}"
      >
        ${new Array(Number(this.review.stars)).fill(null).map(()=>b`<div class="review-star">${H}</div>`)}
      </div>
      -
    `}get createDateTemplate(){var e,t;if(!(!((e=this.review)===null||e===void 0)&&e.createdate)||!(!((t=this.review)===null||t===void 0)&&t.reviewdate))return x;let i=new Date(this.review.reviewdate),r=new Date(this.review.createdate),o=r.toLocaleString("en-us",{month:"long",day:"numeric",year:"numeric"}),c=i.getTime()!==r.getTime()?"(edited)":"";return y(`${o} ${c}`)}generateDomId(){var e;return!((e=this.review)===null||e===void 0)&&e.createdate?`review-${Date.parse(this.review.createdate.toString())}`:""}truncateContent(e,t){return this.showTruncatedContent||this.bypassTruncation?e:A(e,t)}prepReview(e){return M(j(e))}async deleteReview(){if(!this.review||!this.identifier||!confirm(y("Are you sure you want to delete this review?")))return;let e=`${this.baseHost}/edit-reviews.php?identifier=${this.identifier}&deleteReviewer=${this.review.reviewer}&deleteReviewerItemname=${this.review.reviewer_itemname}&csrf_token=${this.csrfToken}`;try{await fetch(e,{method:"POST"}),this.deleteMsg="This review has been queued for deletion."}catch{this.deleteMsg="Sorry, we were unable to delete this review."}}static get styles(){return J`
      :host {
        font-family: var(
          --ia-font-stack,
          'Helvetica Neue',
          Helvetica,
          Arial,
          sans-serif
        );

        font-size: inherit;
        --container-bg-color: #fbfbfd;
        --container-border-color: #999999;
      }

      .review {
        position: relative;
        padding-right: 30px;
      }

      .error {
        color: var(--error-color, #cc0000);
      }

      .top-line {
        margin-bottom: 0.5rem;
      }

      .top-line > * {
        display: inline-block;
      }

      .review-star {
        width: 1rem;
        display: inline-block;
      }

      .simple-link,
      .body a {
        color: var(--link-color, #4b64ff);
        text-decoration: none;
        background: transparent;
        border: none;
        padding: 0px;
      }

      .simple-link:hover,
      .body a:hover {
        cursor: pointer;
        text-decoration: underline;
      }

      .subject {
        margin-bottom: 0.5rem;
      }

      .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0;
        background: none;
        border: 0;
      }

      .delete-btn:hover {
        cursor: pointer;
      }

      .delete-icon {
        width: 20px;
        mix-blend-mode: multiply;
      }
    `}};u([R({type:Object})],v.prototype,"review",void 0);u([R({type:String})],v.prototype,"identifier",void 0);u([R({type:Number})],v.prototype,"maxSubjectLength",void 0);u([R({type:Number})],v.prototype,"maxBodyLength",void 0);u([R({type:String})],v.prototype,"baseHost",void 0);u([R({type:String})],v.prototype,"csrfToken",void 0);u([R({type:Boolean})],v.prototype,"canDelete",void 0);u([R({type:Boolean})],v.prototype,"bypassTruncation",void 0);u([N()],v.prototype,"showTruncatedContent",void 0);u([N()],v.prototype,"deleteMsg",void 0);u([O(".reviewer-link")],v.prototype,"reviewerLink",void 0);u([O("article.review")],v.prototype,"reviewArticle",void 0);v=u([Q("ia-review")],v);var l=class extends ie{constructor(){super(...arguments),this.token="",this.baseHost="https://archive.org",this.endpointPath="/write-review.php",this.submitterScreenname="Anonymous",this.bypassRecaptcha=!1,this.currentStars=0,this.currentSubjectLength=0,this.currentBodyLength=0,this.formCanSubmit=!1,this.submissionInProgress=!1,this.RECAPTCHA_ERROR_MESSAGE="Could not validate review. Please try again later.",this.GENERIC_ERROR_MESSAGE="There's been a temporary error. Please wait a moment and try again."}render(){return p`<form id="review-form" @submit=${this.handleSubmit}>
      ${this.unrecoverableError?this.unrecoverableErrorTemplate:p`
            <span class="inputs">
              ${this.starsInputTemplate} ${this.subjectInputTemplate}
              ${this.bodyInputTemplate} ${this.hiddenInputsTemplate}
            </span>
          `}
      ${this.recaptchaMessageTemplate} ${this.recoverableErrorTemplate}
      ${this.actionButtonsTemplate}
    </form>`}willUpdate(e){var t,i,r,o,c,f,k,L;e.has("oldReview")&&(this.currentStars=(i=(t=this.oldReview)===null||t===void 0?void 0:t.stars)!==null&&i!==void 0?i:0,this.currentSubjectLength=(c=(o=(r=this.oldReview)===null||r===void 0?void 0:r.reviewtitle)===null||o===void 0?void 0:o.length)!==null&&c!==void 0?c:0,this.currentBodyLength=(L=(k=(f=this.oldReview)===null||f===void 0?void 0:f.reviewbody)===null||k===void 0?void 0:k.length)!==null&&L!==void 0?L:0),e.has("recaptchaManager")&&!this.bypassRecaptcha&&this.recaptchaManager&&this.setupRecaptcha(),e.has("unrecoverableError")&&(this.formCanSubmit=this.checkSubmissionAllowed()),(e.has("currentSubjectLength")||e.has("currentBodyLength")||e.has("maxSubjectLength")||e.has("maxBodyLength"))&&(this.formCanSubmit=this.checkSubmissionAllowed())}get unrecoverableErrorTemplate(){return this.unrecoverableError?p`
          <div class="unrecoverable-error">
            <span class="error-msg">${m(this.unrecoverableError)}</span>
          </div>
        `:S}get recoverableErrorTemplate(){return this.recoverableError?p`
          <div class="recoverable-error">
            ${se(this.sanitizeErrorMsg(m(this.recoverableError)))}
          </div>
        `:S}get recaptchaMessageTemplate(){return this.bypassRecaptcha?S:p`
      <span class="recaptcha-disclaimer"
        >${m(p`This site is protected by reCAPTCHA and the Google
            <a
              target="_blank"
              class="inline-link"
              href="https://policies.google.com/privacy"
              >Privacy Policy</a
            >
            and
            <a
              target="_blank"
              class="inline-link"
              href="https://policies.google.com/terms"
              >Terms of Service</a
            >
            apply.`)}</span
      >
    `}get starsInputTemplate(){return p`
      <div class="form-heading rating">
        <label for="stars-field">${m("Rating (optional)")}</label>
      </div>
      <input
        type="hidden"
        name="field_stars"
        id="stars-input"
        .value=${this.currentStars.toString()}
        required
      />
      <div class="stars">
        ${[1,2,3,4,5].map(e=>this.renderStar(e))}
        <button
          type="button"
          class="clear-stars-btn"
          @click=${this.handleClearBtnClicked}
        >
          ${m("Clear")}
        </button>
      </div>
    `}get subjectInputTemplate(){var e,t;return p`
      <span id="subject-input" class="input-box ${this.maxSubjectLength&&this.currentSubjectLength>this.maxSubjectLength?"error":""}"
      ><div class="form-heading">
        <label for="field_reviewtitle">${m("Subject")}</label>
        ${this.maxSubjectLength?p`<div class="char-count subject">
                ${this.currentSubjectLength}/${this.maxSubjectLength}
              </div>`:S}
      </div>
      <input
        type="text"
        name="field_reviewtitle"
        id="field_reviewtitle"
        .value=${(t=(e=this.oldReview)===null||e===void 0?void 0:e.reviewtitle)!==null&&t!==void 0?t:""}
        @input=${this.handleSubjectChanged}
        required
    />${this.maxSubjectLength?p`
            <div class="input-error">
              ${m(`Subject may only have ${this.maxSubjectLength} characters`)}
            </div>
          `:S}</div></span>
    `}get bodyInputTemplate(){var e,t;return p`
      <span
        id="body-input"
        class="input-box ${this.maxBodyLength&&this.currentBodyLength>this.maxBodyLength?"error":""}"
        ><div class="form-heading">
          <label for="field_reviewbody">${m("Review")}</label>
          ${this.maxBodyLength?p`<div class="char-count body">
                ${this.currentBodyLength}/${this.maxBodyLength}
              </div>`:S}
        </div>
        <textarea
          name="field_reviewbody"
          id="field_reviewbody"
          .value=${(t=(e=this.oldReview)===null||e===void 0?void 0:e.reviewbody)!==null&&t!==void 0?t:""}
          rows="10"
          cols="50"
          required
          @input=${this.handleBodyChanged}
        ></textarea>
        ${this.maxBodyLength?p`
              <div class="input-error">
                ${m(`Review may only have ${this.maxBodyLength} characters`)}
              </div>
            `:S}
      </span>
    `}get hiddenInputsTemplate(){return p`
      <input type="hidden" name="field_reviewtoken" .value=${this.token} />
      ${this.identifier?p`<input
            type="hidden"
            name="identifier"
            .value=${this.identifier}
          />`:S}
    `}get actionButtonsTemplate(){return p`<div class="action-btns">
      <button
        type="button"
        class="ia-button dark"
        data-testid="cancel-btn"
        @click=${this.cancelReviewEdit}
      >
        ${m("Cancel")}
      </button>
      <button
        type="submit"
        class="ia-button primary"
        name="submit"
        ?disabled=${!this.formCanSubmit||this.submissionInProgress}
      >
        ${this.submissionInProgress?p`
              <span class="loading-indicator" alt="Loading indicator">
                <ia-activity-indicator></ia-activity-indicator>
              </span>
            `:m("Submit review")}
      </button>
    </div>`}renderStar(e){let t=e===this.currentStars,i=m(`Rate ${e>1?`${e} stars`:"1 star"}`);return p`
      <button
        class="star star-${e}"
        title=${t?m("Clear rating"):i}
        @click=${r=>this.handleStarClicked(r,e)}
      >
        ${e<=this.currentStars?I:D}
      </button>
    `}async setupRecaptcha(){var e;try{this.recaptchaWidget=await((e=this.recaptchaManager)===null||e===void 0?void 0:e.getRecaptchaWidget())}catch{this.unrecoverableError=this.RECAPTCHA_ERROR_MESSAGE}}sanitizeErrorMsg(e){return ne.sanitize(e,{ALLOWED_TAGS:["a","b","br"]})}async handleSubmit(e){var t;if(e.preventDefault(),!(!this.formCanSubmit||this.submissionInProgress)){if(this.submissionInProgress=!0,this.recoverableError="",!this.reviewForm.reportValidity())return this.stopSubmission();if(!this.fetchHandler)return this.recoverableError=this.GENERIC_ERROR_MESSAGE,this.stopSubmission();try{let i=new URLSearchParams;if(!this.bypassRecaptcha){let o=await this.getRecaptchaToken();if(!o)return this.handleRecaptchaError();i.append("g-recaptcha-response",o??"")}for(let o of new FormData(this.reviewForm))i.append(o[0],o[1]);i.append("submitter","review-form");let r=await this.fetchHandler.fetchApiResponse(`${this.baseHost}${this.endpointPath}`,{method:"POST",includeCredentials:!0,body:i});if(r?.success===!0){this.submissionInProgress=!1;let o=this.generateSubmittedReview(),c=new CustomEvent("reviewUpdated",{detail:o});this.dispatchEvent(c)}else this.recoverableError=(t=r.error)!==null&&t!==void 0?t:this.GENERIC_ERROR_MESSAGE,this.stopSubmission()}catch(i){console.error(i),this.recoverableError=this.GENERIC_ERROR_MESSAGE,this.stopSubmission()}}}generateSubmittedReview(){var e,t,i,r,o,c;let f=new Date().toDateString();return new le({reviewtitle:this.reviewForm.field_reviewtitle.value,reviewbody:this.reviewForm.field_reviewbody.value,stars:this.reviewForm.field_stars.value,reviewdate:f,reviewer:(t=(e=this.oldReview)===null||e===void 0?void 0:e.reviewer)!==null&&t!==void 0?t:this.submitterScreenname,reviewer_itemname:(r=(i=this.oldReview)===null||i===void 0?void 0:i.reviewer_itemname)!==null&&r!==void 0?r:this.submitterItemname,createdate:(c=this.dateToString((o=this.oldReview)===null||o===void 0?void 0:o.createdate))!==null&&c!==void 0?c:f})}dateToString(e){return e instanceof Date?e.toDateString():e}async getRecaptchaToken(){if(!this.recaptchaWidget){this.handleRecaptchaError();return}try{return await this.recaptchaWidget.execute()}catch{this.handleRecaptchaError();return}}handleRecaptchaError(){this.recoverableError=this.RECAPTCHA_ERROR_MESSAGE,this.stopSubmission()}stopSubmission(){this.submissionInProgress&&(this.submissionInProgress=!1)}cancelReviewEdit(){let e=new CustomEvent("reviewEditCanceled");this.dispatchEvent(e)}handleStarClicked(e,t){e.preventDefault(),this.setStars(t)}handleClearBtnClicked(e){e.preventDefault(),this.currentStars=0}setStars(e){this.currentStars=e===this.currentStars?0:e}handleSubjectChanged(e){let t=e.target;this.currentSubjectLength=t.value.length}handleBodyChanged(e){let t=e.target;this.currentBodyLength=t.value.length}checkSubmissionAllowed(){return!(this.unrecoverableError||!this.currentBodyLength||!this.currentSubjectLength||this.maxSubjectLength&&this.currentSubjectLength>this.maxSubjectLength||this.maxBodyLength&&this.currentBodyLength>this.maxBodyLength)}static get styles(){return[ae,te`
        .form-heading {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding-top: 15px;
        }

        .form-heading.rating {
          padding-top: 0;
        }

        .form-heading label {
          font-size: 1.6rem;
          font-weight: bold;
        }

        label {
          display: inline-block;
          margin-bottom: 5px;
        }

        textarea,
        input[type='text'],
        .unrecoverable-error {
          padding: 5px;
          width: calc(100% - 10px);
          font-family: inherit;
          border-radius: 5px;
          border: 1px solid var(--container-border-color, #999999);
        }

        .input-box.error input,
        .input-box.error textarea {
          border: 2px solid var(--container-error-color, #ea0202);
        }

        .input-box.error .char-count,
        .input-error,
        .unrecoverable-error,
        .recoverable-error {
          color: var(--container-error-color, #ea0202);
        }

        .input-error {
          display: none;
        }

        .input-box.error .input-error {
          display: block;
          text-align: right;
          padding-top: 5px;
        }

        .inline-link {
          color: var(--container-link-color, #4f65f5);
          text-decoration: none;
        }

        .inline-link:hover {
          text-decoration: underline;
        }

        .stars {
          display: flex;
          flex-direction: row;
          gap: 2px;
          align-items: center;
        }

        .star {
          all: unset;
          height: 30px;
          width: 30px;
        }

        .star:hover {
          cursor: pointer;
        }

        .clear-stars-btn,
        .recoverable-error a {
          padding: 0 5px;
          color: var(--container-link-color, #4f65f5);
          font-family: inherit;
          border: none;
          background: transparent;
          display: inline-block;
          padding-top: 5px;
        }

        .clear-stars-btn:hover,
        .recoverable-error a:hover {
          cursor: pointer;
          text-decoration: underline;
        }

        .action-btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          padding-top: 15px;
        }

        .ia-button:disabled {
          opacity: 0.75;
        }

        .ia-button:disabled:hover {
          cursor: not-allowed;
        }

        .unrecoverable-error {
          min-height: 50px;
          padding: 5px;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: var(--container-bg-color, #fbfbfd);
        }

        .loading-indicator {
          display: block;
          width: 20px;
          height: 20px;
          margin-top: 2px;
          --activityIndicatorLoadingRingColor: #fff;
          --activityIndicatorLoadingDotColor: #fff;
        }

        .recaptcha-disclaimer {
          font-size: 1.2rem;
        }

        @media only screen and (max-width: 350px) {
          .action-btns {
            flex-direction: column-reverse;
            align-items: center;
          }
        }
      `]}};d([w({type:String})],l.prototype,"identifier",void 0);d([w({type:String})],l.prototype,"token",void 0);d([w({type:String})],l.prototype,"baseHost",void 0);d([w({type:String})],l.prototype,"endpointPath",void 0);d([w({type:String})],l.prototype,"submitterScreenname",void 0);d([w({type:String})],l.prototype,"submitterItemname",void 0);d([w({type:Object})],l.prototype,"oldReview",void 0);d([w({type:String})],l.prototype,"unrecoverableError",void 0);d([w({type:Number})],l.prototype,"maxSubjectLength",void 0);d([w({type:Number})],l.prototype,"maxBodyLength",void 0);d([w({type:Object})],l.prototype,"fetchHandler",void 0);d([w({type:Object})],l.prototype,"recaptchaManager",void 0);d([w({type:Boolean})],l.prototype,"bypassRecaptcha",void 0);d([E()],l.prototype,"currentStars",void 0);d([E()],l.prototype,"currentSubjectLength",void 0);d([E()],l.prototype,"currentBodyLength",void 0);d([E()],l.prototype,"recoverableError",void 0);d([E()],l.prototype,"formCanSubmit",void 0);d([E()],l.prototype,"submissionInProgress",void 0);d([oe("#review-form")],l.prototype,"reviewForm",void 0);l=d([re("ia-review-form")],l);import{__decorate as a}from"/tslib?target=es2022";import{css as de,html as g,LitElement as ce,nothing as _}from"/lit@^2.8.0?target=es2022";import{property as h,customElement as he,queryAll as pe,state as T}from"/lit@^2.8.0/decorators?target=es2022";import{msg as $,str as ve}from"/@lit/localize@^0.12.2?target=es2022";import{IaFetchHandler as ue}from"/@internetarchive/fetch-handler-service@^1.0.1?target=es2022";import{iaButtonStyles as me}from"/@internetarchive/ia-styles@^1.0.0?target=es2022";var s=class extends ce{constructor(){super(...arguments),this.reviews=[],this.reviewsDisabled=!1,this.reviewsFrozen=!1,this.canDelete=!1,this.displayReviewsByDefault=!1,this.maxInitialReviews=5,this.baseHost="https://archive.org",this.token="",this.endpointPath="/write-review.php",this.submitterScreenname="Anonymous",this.bypassRecaptcha=!1,this.reviewAddEditRequested=!1,this.fetchHandler=new ue,this.displayReviewForm=!1,this.showAllReviews=!1,this.filteredReviews=[],this.reviewsCount=0,this.recaptchaActivated=!1}render(){return this.reviewsDisabled?this.reviewsDisabledTemplate:this.reviewsCount===0&&!this.displayReviewForm?this.noReviewsMsgTemplate:g`
      <div class="reviews-list">
        ${this.reviewsFrozen?g`<div class="message">
              ${$("Reviews can no longer be added to this item.")}
            </div>`:_}
        ${this.editableCurrentReviewTemplate}
        ${this.visibleReviews.map(e=>this.renderReview(e))}
        ${this.showMoreButtonTemplate}
      </div>
    `}willUpdate(e){(e.has("reviews")||e.has("submitterItemname"))&&(this.reviewsCount=this.reviews.length,this.sortFilterReviews()),e.has("displayReviewForm")&&this.displayReviewForm===!0&&!this.bypassRecaptcha&&!this.recaptchaActivated&&(this.recaptchaActivated=!0)}get visibleReviews(){return this.showAllReviews||this.displayReviewsByDefault?this.filteredReviews:this.filteredReviews.slice(0,this.maxInitialReviews)}get reviewsDisabledTemplate(){return g`<div class="message">
      ${$("Reviews have been disabled for this item.")}
    </div>`}get noReviewsMsgTemplate(){return this.reviewsFrozen?g`
        <div class="message">
          ${$("Reviews cannot be added to this item.")}
        </div>
      `:g`
      <div class="message">
        ${$("There are no reviews yet.")}
        ${$(g`
          Be the first one to
          <button
            class="ia-button link no-reviews-btn"
            @click=${this.addEditReview}
          >
            write a review</button
          >.
        `)}
      </div>
    `}get showMoreButtonTemplate(){let e=this.filteredReviews.length-this.visibleReviews.length;return e<=0?_:g`
      <button
        class="ia-button link show-more-btn"
        @click=${this.showMoreReviews}
      >
        ${e===1?$("Show 1 more review"):$(ve`Show ${e} more reviews`)}
      </button>
    `}get editableCurrentReviewTemplate(){return!this.displayReviewForm&&!this.currentReview?_:g`<div class="own-review-container">
      ${this.displayReviewForm?g`<ia-review-form
            .identifier=${this.identifier}
            .oldReview=${this.currentReview}
            .baseHost=${this.baseHost}
            .endpointPath=${this.endpointPath}
            .submitterItemname=${this.submitterItemname}
            .submitterScreenname=${this.submitterScreenname}
            .maxSubjectLength=${this.maxSubjectLength}
            .maxBodyLength=${this.maxBodyLength}
            .token=${this.token}
            .unrecoverableError=${this.reviewSubmissionError}
            .fetchHandler=${this.fetchHandler}
            .recaptchaManager=${this.recaptchaActivated?this.recaptchaManager:void 0}
            ?bypassRecaptcha=${this.bypassRecaptcha}
            @reviewUpdated=${this.handleReviewUpdate}
            @reviewEditCanceled=${this.handleEditCanceled}
          ></ia-review-form>`:this.renderReview(this.currentReview)}
    </div>`}sortFilterReviews(){let e,t=[];this.reviews.forEach(i=>{i.reviewer_itemname!==this.submitterItemname?t.push(i):e||(e=i)}),this.currentReview=e,this.filteredReviews=this.sortReviews(t)}sortReviews(e){return[...e].sort((i,r)=>i.createdate&&r.createdate?new Date(r.createdate).getTime()-new Date(i.createdate).getTime():0)}renderReview(e){return e?g`<ia-review
      .review=${e}
      .identifier=${this.identifier}
      .baseHost=${this.baseHost}
      .csrfToken=${this.token}
      ?canDelete=${this.canDelete}
      ?bypassTruncation=${this.displayReviewsByDefault}
    ></ia-review>`:_}async showMoreReviews(){var e;let t=this.visibleReviews.length;this.showAllReviews=!0,await this.updateComplete;let i=(e=this.listedReviews)===null||e===void 0?void 0:e[t];await i?.updateComplete,i?.focus()}addEditReview(){this.bypassRecaptcha||(this.recaptchaActivated=!0),this.displayReviewForm=!0}handleReviewUpdate(e){!this.currentReview&&e.detail&&(this.dispatchEvent(new CustomEvent("newReviewAdded")),this.reviewsCount+=1),this.currentReview=e.detail,this.displayReviewForm=!1}handleEditCanceled(){this.displayReviewForm=!1}static get styles(){return[me,de`
        :host {
          font-family: var(
            --ia-font-stack,
            'Helvetica Neue',
            Helvetica,
            Arial,
            sans-serif
          );

          color: var(--ia-text-color, #2c2c2c);
        }

        .reviews-list {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          width: 100%;
        }

        .own-review-container {
          --error-color: var(--container-error-color, #ea0202);
          --link-color: var(--container-link-color, #4f65f5);
          --container-error-color: #ea0202;
          --container-link-color: #4f65f5;
          --container-bg-color: #fbfbfd;
          --container-border-color: #999999;

          border: 2px solid var(--container-border-color, #999999);
          border-radius: 5px;
          background-color: var(--container-bg-color, #fbfbfd);
          padding: 10px;
        }

        .message {
          font-weight: 200;
        }

        .message .ia-button {
          display: inline;
          vertical-align: baseline;
          padding: 0;
          font-weight: 600;
        }

        /* Two classes, to outrank .ia-button.link's padding */
        .reviews-list .show-more-btn {
          padding: 0;
          font-weight: 600;
          outline-color: currentColor;
          outline-offset: 2px;
        }
      `]}};a([h({type:String})],s.prototype,"identifier",void 0);a([h({type:Array})],s.prototype,"reviews",void 0);a([h({type:Boolean})],s.prototype,"reviewsDisabled",void 0);a([h({type:Boolean})],s.prototype,"reviewsFrozen",void 0);a([h({type:Boolean})],s.prototype,"canDelete",void 0);a([h({type:Boolean})],s.prototype,"displayReviewsByDefault",void 0);a([h({type:Number})],s.prototype,"maxInitialReviews",void 0);a([h({type:Number})],s.prototype,"maxSubjectLength",void 0);a([h({type:Number})],s.prototype,"maxBodyLength",void 0);a([h({type:String})],s.prototype,"baseHost",void 0);a([h({type:String})],s.prototype,"token",void 0);a([h({type:String})],s.prototype,"endpointPath",void 0);a([h({type:String})],s.prototype,"submitterScreenname",void 0);a([h({type:String})],s.prototype,"submitterItemname",void 0);a([h({type:Object})],s.prototype,"recaptchaManager",void 0);a([h({type:Boolean})],s.prototype,"bypassRecaptcha",void 0);a([h({type:String})],s.prototype,"reviewSubmissionError",void 0);a([h({type:Boolean})],s.prototype,"reviewAddEditRequested",void 0);a([h({type:Object})],s.prototype,"fetchHandler",void 0);a([T()],s.prototype,"displayReviewForm",void 0);a([T()],s.prototype,"showAllReviews",void 0);a([T()],s.prototype,"filteredReviews",void 0);a([T()],s.prototype,"currentReview",void 0);a([T()],s.prototype,"reviewsCount",void 0);a([T()],s.prototype,"recaptchaActivated",void 0);a([pe(".reviews-list > ia-review")],s.prototype,"listedReviews",void 0);s=a([he("ia-reviews")],s);export{s as IaReviews,l as ReviewForm};
//# sourceMappingURL=reviews.mjs.map